import { render, staticRenderFns } from "./PmauCover.vue?vue&type=template&id=a4fabbb4&scoped=true&"
import script from "./PmauCover.vue?vue&type=script&lang=js&"
export * from "./PmauCover.vue?vue&type=script&lang=js&"
import style0 from "./PmauCover.vue?vue&type=style&index=0&id=a4fabbb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4fabbb4",
  null
  
)

export default component.exports